<div class="modal-header">
    <h3 class="modal-title" id="modal-title-id">{{LOCALIZATION.workflowProcessDiagram}}</h3>
    <h5 class="modal-subtitle">
		<span [innerHTML]="processData.subtitle | safeHtml"></span>
	</h5>
</div>
<div class="dx-properties modal-body">
  <div style="max-height:600px;overflow-y:auto;overflow-x:hidden">	
	<div [innerHTML]="diagram"></div>
  </div>
</div>
<div class="modal-footer">
    <button class="btn btn-default" type="button" (click)="close()">{{LOCALIZATION.close}}</button>
</div>